import { SmartQuestionStatus } from '@/gen/inventory/v1/control_service_pb'

import type { ControlRow } from '@/pages/control/ag-grid-control/types'

export const getResolvedControlRowClassName = (control?: ControlRow): string =>
  control?.smartQuestion?.status === SmartQuestionStatus.RESOLVED ? 'ag-row-control-resolved' : ''
